import React from "react";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { useTranslation } from "react-i18next";
import { usePreferencesStore } from "../state/preferencesStore";

interface ThemeToggleButtonProps {
  size?: "small" | "medium" | "large";
}

export const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({
  size = "medium",
}) => {
  const { t } = useTranslation();
  const themeMode = usePreferencesStore((s) => s.theme);
  const setTheme = usePreferencesStore((s) => s.setTheme);

  const translations = {
    toggleToLight: t("theme.toggleToLight"),
    toggleToDark: t("theme.toggleToDark"),
  };

  return (
    <Tooltip
      title={
        themeMode === "light"
          ? translations.toggleToDark
          : translations.toggleToLight
      }
    >
      <IconButton
        color="inherit"
        onClick={() => setTheme(themeMode === "light" ? "dark" : "light")}
        aria-label="toggle theme"
        size={size}
      >
        {themeMode === "light" ? <DarkModeIcon /> : <LightModeIcon />}
      </IconButton>
    </Tooltip>
  );
};
